module.exports = __webpack_public_path__ + "img/log.15493345.png";